import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from '@ddc/classnames-js';
import { usePrefs } from 'wsm-common-data';

/**
 * Shared "Show More" button used by the model-card layout containers. The
 * caller owns the visibility decision and supplies the label/handler from
 * `useShowMore`; this component only renders the (identical) control so the
 * grid and responsive layouts don't duplicate the markup.
 */
const ShowMoreButton = ({ label, onClick }) => {
	const { showMoreButtonPadding } = usePrefs();

	return (
		<div
			className={setClassNames([
				'w-100',
				'd-flex',
				showMoreButtonPadding,
				'justify-content-center'
			])}
		>
			<button
				type="button"
				title={label}
				aria-label={label}
				onClick={onClick}
				className="btn btn-default"
				data-testid="show-more-button"
			>
				{label}
			</button>
		</div>
	);
};

ShowMoreButton.propTypes = {
	label: PropTypes.string.isRequired,
	onClick: PropTypes.func.isRequired
};

export default ShowMoreButton;
